<!--
 * @Author: zenghong zenghong@edsz9.com
 * @Date: 2022-08-17 14:00:14
 * @LastEditors: zenghong zenghong@edsz9.com
 * @LastEditTime: 2022-08-17 15:43:07
 * @FilePath: \client-portal\src\views\apps\account-info\accountItem.vue
-->
<template>
  <div class="account-item-container">
    <el-card shadow="always"
                     class="trading-account mb-20">
              <div class="fx-col">
                <span class="name">
                  <span>{{$t('tradeAccountType.'+ accountList[0].tradeAccountType)}}</span>
                  <el-tooltip v-if="curAccountInfo.isDormant" popper-class="account-tip" effect="dark"  :content="$t('accountInfo.accountDormant', {accountNumber: curAccountInfo.tradeAccountNumber})" placement="top-start" >
                    <span class="what-dormant" >?</span>
                  </el-tooltip>
                  <span class="account-status" v-if="curAccountInfo.isDormant ">{{$t('common.dormant ')}}</span>
                </span>

                <span class="status">{{$t('accountInfo.'+ selectItem.status)}}</span>
              </div>
              <div class="dis-input" v-if="accountList.length===1">
                {{accountList[0].tradeAccountNumber}}
              </div>
              <el-select v-else v-model="num" @change="changeHandle" style="margin-bottom:12px;width:100%;height:45px">
                <el-option v-for="val in accountList" :key="val.tradeAccountNumber" :value="val.tradeAccountNumber">{{val.tradeAccountNumber}}</el-option>
              </el-select>
              <div class="fx-col">
                <span class="left">
                  <div v-if="['MT5', 'MF', 'BULLION_MARGIN'].includes(selectItem.tradeAccountType)" class="balance">{{$t('accountInfo.balance')}}</div>
                  <div v-else-if="selectItem.tradeAccountType === 'FUTURES_MARGIN' || selectItem.tradeAccountType === 'FUTURES_DAYTRADING_MARGIN'" class="balance">{{$t('accountInfo.todayBalance')}}</div>
                  <div v-else class="balance">{{selectItem.tradeAccountType === 'INTERACTIVE_BROKER_INTEGRATED_MARGIN' ? '' : $t('accountInfo.netCashBalance')}}</div>
                </span>
                <span class="right">
                  <span class="v-balance" v-if="selectItem.tradeAccountType !== 'INTERACTIVE_BROKER_INTEGRATED_MARGIN'">{{isNaN(selectItem.total_balance) ? selectItem.total_balance : financial(selectItem.total_balance,selectItem.base_currency)}}</span>
                </span>
              </div>
            </el-card>
  </div>
</template>

<script>
export default {
props: {
    accountList: {
      type: Array,
      default: () => []
    },
    selectItem: {
      type: Object,
      default: () => {}
    },
    typeKey: {
      type: String,
      default: ''
    }
  },
data() {
    return {
      num: '',
      curAccountInfo: {}
    }
  },
watch: {
  selectItem: {
    handler(val) {
      this.num = val.tradeAccountNumber
      this.curAccountInfo = this.selectItem
    },
    deep: true,
    immediate: true
  }
},
mounted() {
  if (this.accountList.length === 1) {
    this.curAccountInfo = this.accountList[0]
  } else {
    this.curAccountInfo = this.selectItem
  }
},
methods: {
    changeHandle(val) {
      this.$emit('changeHandle', val, this.typeKey)
    },
    financial (x, currency) {
      let amount = this.Util.formatCurrency(x)
      return `${currency} ${amount}`
    }
  }
}
</script>

<style lang="scss" scoped>
.fx-col{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .left{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
}
.account-status{
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #24282D;
  background: #F3F4F6;
  padding: 5px 10px;
  border-radius: 5px;
}
.what-dormant{
 margin-left: 10px;
 cursor: pointer;
}
</style>
<style lang="scss" >
.account-tip{
  width: 400px;
}
</style>
